import $ from 'jquery'

const DEFAULT_EXPIRATION_TIME_MS = 60000 * 5 // 5 minutes

class LocalMemoryCache {
  constructor({ expireInMs }) {
    this.expireInMs = expireInMs || DEFAULT_EXPIRATION_TIME_MS

    this._data = {}
  }

  /* return cached value if it exists and has not expired. Otherwise returns undefined */
  get(key) {
    if (this.exists(key)) {
      return this._data[key].data
    }
    return undefined
  }

  exists(key) {
    return !!this._data[key]
  }

  set(key, val) {
    if (typeof key === 'string' && key) {
      this.unset(key)
      this._data[key] = {
        _timeout: setTimeout(this.unset.bind(this, key), this.expireInMs),
        data: val
      }
    } else {
      throw new Error('Key must be a non-empty string')
    }
  }

  unset(key) {
    if (this._data[key]) {
      clearTimeout(this._data[key]._timeout)
    }
    delete this._data[key]
  }
}

const defaultMemoryCache = new LocalMemoryCache({ expireInMs: DEFAULT_EXPIRATION_TIME_MS })

function ajaxCacheWrapper(cache, ajaxSetup, options = { refetch: false }) {
  let cacheKey = JSON.stringify(ajaxSetup)
  if (options && options.refetch) {
    cache.unset(cacheKey)
  }
  if (!cache.exists(cacheKey)) {
    return $.ajax({
      ...ajaxSetup,
      success: data => {
        cache.set(cacheKey, data)
      }
    })
  }
  return Promise.resolve(cache.get(cacheKey))
}

export { defaultMemoryCache, ajaxCacheWrapper, LocalMemoryCache }
